import VisuallyHidden from './visually-hidden.element.js';

export default VisuallyHidden;

VisuallyHidden.define('wje-visually-hidden', VisuallyHidden);
